import Markdown from 'react-markdown';
import clsx from 'clsx';

import styles from './ValueCard.module.css';

interface ValueCardProps {
  text: string;
  variant: 'solid' | 'gradient';
  className?: string;
}

export default function ValueCard({ text, variant, className }: ValueCardProps) {
  return (
    <div className={clsx(styles.card, styles[variant], className)}>
      <div className={styles.text}>
        <Markdown>{text}</Markdown>
      </div>
    </div>
  );
}
